"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordComponent = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var input_1 = require("../../components/input/input");
var input_state_1 = require("../../components/input/input.state");
var input_state_group_1 = require("../../components/input/input.state.group");
var mithril_component_1 = require("../../components/mithril.component");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var CSS = {
    container: 'c-ForgotPassword',
    heading: 'c-ForgotPassword__Heading',
    acceptButton: 'c-ForgotPassword__Accept'
};
(0, theme_1.addStyles)((_a = {},
    _a[CSS.container] = {
        display: 'flex',
        'flex-direction': 'column',
        'align-items': 'center'
    },
    _a[CSS.acceptButton] = {
        width: '300px'
    },
    _a));
var ForgotPasswordComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ForgotPasswordComponent, _super);
    function ForgotPasswordComponent(ctrl) {
        var _this = _super.call(this) || this;
        _this.email = new input_state_1.InputState(i18n_1.T.PASSWORD_FORGOT_EMAIL);
        _this.form = new input_state_group_1.IkeInputStateGroup();
        _this.ctrl = ctrl;
        _this.form.add(_this.email);
        _this.email.isRequired = true;
        _this.email.type = input_state_1.InputStateTypes.TEXT;
        return _this;
    }
    ForgotPasswordComponent.prototype.onCreate = function () {
        var _this = this;
        this.autorun(function (_) { return _this.validate(); });
    };
    Object.defineProperty(ForgotPasswordComponent.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('form', { className: CSS.container }, [
                (0, mithril_1.m)('h3', (0, i18n_1.Translate)(i18n_1.T.PASSWORD_FORGOT_TITLE)),
                this.ctrl.completedReset ? null : input_1.Input.view(this.email),
                this.ctrl.completedReset ? this.viewNextSteps() : this.viewAcceptButton()
            ]);
        },
        enumerable: false,
        configurable: true
    });
    ForgotPasswordComponent.prototype.viewAcceptButton = function () {
        var child = this.ctrl.loading ? spinner_1.Spinner.view() : (0, i18n_1.Translate)(i18n_1.T.PASSWORD_FORGOT_ACCEPT);
        var disabled = this.ctrl.loading || !this.form.canSubmit;
        return (0, mithril_1.m)('button', {
            className: "".concat(CSS.acceptButton, " mdl-button mdl-button--raised mdl-button--accent"),
            type: 'submit',
            onclick: this.submit,
            disabled: disabled
        }, child);
    };
    ForgotPasswordComponent.prototype.viewNextSteps = function () {
        return (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.PASSWORD_FORGOT_SUCCESS));
    };
    ForgotPasswordComponent.prototype.submit = function () {
        if (!this.form.canSubmit) {
            services_1.Logger.error('Attempted to submit invalid form...');
            return false;
        }
        this.ctrl.requestPasswordReset(this.email.value);
        // Don't submit form
        return false;
    };
    ForgotPasswordComponent.prototype.validate = function () {
        if (!this.ctrl.isValidEmail(this.email.value)) {
            this.email.setError(i18n_1.T.EMAIL_INVALID);
        }
        else {
            this.email.setError('');
        }
    };
    tslib_1.__decorate([
        mobx_1.action.bound
    ], ForgotPasswordComponent.prototype, "submit", null);
    return ForgotPasswordComponent;
}(mithril_component_1.IMithrilStateComponent));
exports.ForgotPasswordComponent = ForgotPasswordComponent;
//# sourceMappingURL=forgot.password.js.map